module.exports = __webpack_public_path__ + "static/media/product-3-full.768a7e12.jpg";